import { addStream } from '../../epicStore'
import { pluck, map, tap, mapTo } from 'rxjs/operators'
import { ofType, StateObservable } from 'redux-observable'
import { SyncClient } from 'twilio-sync'
import { ReduxAction, State } from '../../../reducers/reducerType'
import { setSyncListenersAdded } from '../../../actions/sync/syncActions'
import { syncType } from '../../../actions/sync'
import events$ from './addEventsDataEvents'
import { Observable } from 'rxjs'

const addEvents$ = (actions$, state$: StateObservable<State>) => actions$.pipe(
  ofType(syncType.SYNC_CLIENT_ESTABLISHED),
  pluck<ReduxAction, SyncClient>('payload'),
  map((client: SyncClient) => events$(client, state$)),
  tap((stream$: Observable<ReduxAction>) => addStream(stream$)),
  mapTo(setSyncListenersAdded())
)

export default addEvents$
